import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRealtimeDrivers } from 'Core/hooks';
import { SidePanel, SidePanelBody, SidePanelHeader, SidePanelFooter } from '@gpstrackit/gtc-react-controls';
import { NotificationManager } from 'Components/Notifications';
import moment from 'moment';

import {
    Grid
} from '@mui/material';

import { Button, Input, Icons, Switch, IconButton, Select, TimeFrame, useTimeFrameComponent, /* DragAndDrop as DragDropList, */ MenuComponent, Pill } from '@gpstrackit/gtc-react-controls';
import { getDateFromReactCalendarToUtc } from '../../../../../../components/Map/utils';
import { ColorsToRouteStatus } from '../../../../../../components/Map/providers/enums';

import { useIntl } from 'react-intl';

import {
    openModalRoutesTrackerFilter,
    routesTrackerSearchRoutesWithFilters,
    setRoutesTrackerFilters,
    clearFiltersRoutesTracker,
    catalogLoad
  } from 'Redux/actions';



const ModalRouteFilters = (props) => {


    const { messages, locale } = useIntl();

    const [driversSelect, setDriversSelect] = useState([])
    const [statusSelect, setStatusSelect] = useState([])
    const [noDriverFilter, setNoDriverFilter] = useState({
        color: '#66bb6a',
        id: '1',
        label: messages['fsmRoute_routesTracker_modalfilters_no_driver'],
        variant: 'none'
    })
    const dispatch = useDispatch();

    const defaultFrame = "today"

    const timeFrameOptions = [
        { id: "custom", label: messages['date_custom'] },
        { id: "today", label: messages['date_today'] },
        { id: "yesterday", label: messages['date_yesterday'] },
        { id: "week", label: messages['date_this_week'] },
        { id: "lastWeek", label: messages['date_last_week'] },
        { id: "thisMonth", label: messages['date_this_month'] },
        { id: "lastMonth", label: messages['date_last_month'] },
        { id: "quarter", label: messages['date_this_quarter'] },
        { id: "lastQuarter", label: messages['date_last_quarter'] },
    ];
    
    const ListRouteStatus = ColorsToRouteStatus.map((element) => {
        return {
            ...element,
            label: messages[element.messages]
        }
    });

    const timeFrame = useTimeFrameComponent(timeFrameOptions)

    const dateformat = useSelector(state => state.securityRedux.user.dateformat);
    const open = useSelector(state => state.routesTrackerModalFilterRedux?.open);
    const drivers = useRealtimeDrivers({ trackFields: ['id', 'name', 'externalId', 'disabled', 'tags'] });
    const loadingRoutes = useSelector(state => state.routesTrackerRedux.loadingRoutes);
    const routeName = useSelector(state => state.routesTrackerModalFilterRedux.filters.routeName);
    const timeFrameOptionSelected = useSelector(state => state.routesTrackerModalFilterRedux?.filters?.timeFrameOptionSelected);
    const timeZoneUser = useSelector((state) => state.securityRedux.user.timeZone);

    useEffect(()=> {
        dispatch(catalogLoad(["drivers"], true))
        dispatch(setRoutesTrackerFilters({
            drivers: driversSelect,
            timeFrameOptionSelected: timeFrameOptions[1], //select by default the current day
            dateStart: moment.utc(new Date()).format(),
            dateEnd:  moment.utc(new Date()).format(),
            noDriver: noDriverFilter?.variant || false,
            status: statusSelect
        }))
        return () => {
            dispatch(setRoutesTrackerFilters({}))
            setNoDriverFilter({})
        }
    },[])

    useEffect(()=> {
        setNoDriverFilter({
            color: '#66bb6a',
            id: '1',
            label: messages['fsmRoute_routesTracker_modalfilters_no_driver'],
            variant: 'none'
        })
    }, [locale])


    const handleToggle = () => {
        dispatch(openModalRoutesTrackerFilter({open: !open}));
    }

    const clearFilters = () => {
        setDriversSelect([])
        setStatusSelect([])

        timeFrame.defaultvalue(defaultFrame);
        //let newFilters = { form: null, driver: null };
        //setFilters(newFilters);

        //timeFrame.onChangeDateRange(moment(startDate),moment(endDate))


        

    }

    const searchRoutesToFilter = () => {

        const conditions = []

        let fields = []
        let terms = []

        fields.push("isTemplate")
        terms.push(0)

        conditions.push({
            fields: fields,
            terms: terms,
            exact: 1
        })

        
        if(routeName){
            fields = []
            terms = []
            fields.push("title")
            terms.push(routeName) 

            conditions.push({
                fields: fields,
                terms: terms
            })
        }

        //is Assigned Route
        if(driversSelect?.length > 0){

            fields = []
            terms = []
            fields.push("driverId")
            driversSelect.forEach((item) => {
                terms.push(item.driverId)
            })

            conditions.push({
                fields: fields,
                terms: terms,
                exact: 1
            })
        }

        if(statusSelect?.length > 0){
            fields = []
            terms = []
            fields.push("status")
            statusSelect.forEach((item) => {
                terms.push(item.name)
            })

            conditions.push({
                fields: fields,
                terms: terms,
                exact: 1
            })
        }
        

        if(noDriverFilter?.variant == 'filled'){
            fields = []
            terms = []
            //add the null condition for no selectedd driver
            if(conditions.length > 0 && conditions.find((item) => item.fields.includes("driverId"))){
                conditions.forEach((item) => {
                    if(item.fields.includes("driverId")){
                        item.terms.push(null);
                    }
                })
            }else{
                //iff no have a previus filter for null driver
                fields.push("driverId")
                terms.push(null)

                conditions.push({
                    fields: fields,
                    terms: terms,
                    exact: 1
                })
            }
        }
        const dateStartUTC = getDateFromReactCalendarToUtc(timeFrame?.startDate, timeZoneUser);
        const dateEndUTC = getDateFromReactCalendarToUtc(timeFrame?.endDate, timeZoneUser);

        conditions.push({
            range: {
                fields: ['scheduledAt'],
                GTE: dateStartUTC,
                LTE: dateEndUTC
            }
        })       
        
        dispatch(setRoutesTrackerFilters({
            drivers: driversSelect,
            timeFrameOptionSelected: timeFrame.option,
            dateStart: dateStartUTC,
            dateEnd:  dateEndUTC,
            status: statusSelect
        }))

        dispatch(routesTrackerSearchRoutesWithFilters({ conditions, offset: 0, limit: 10 }));

    }

    useEffect(() => {
        searchRoutesToFilter()
    },[driversSelect, timeFrame?.startDate, timeFrame?.endDate, noDriverFilter, statusSelect ])

    return (
        <div id='idPanelRouteModal'>
        <SidePanel 
            isOpen={open} 
            onToggle={handleToggle} 
            hiddenButton={false} 
            style={{ width: '350px', transform: 'translateX(350px)' }} 
            //position={"right"}
            //classSidePanel={args.classSidePanel}
            //classPanelContent={args.classPanelContent}
            //contentStyle={args.contentStyle}
        >
            <SidePanelHeader>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start"
                >
                    <Grid item>
                        <h2 style={{ margin: 0 }}>
                            {messages['fsmRoute_routesTracker_modalfilters_title']}
                        </h2>
                        <span
                            className='btn-link'
                            onClick={() => {
                                clearFilters()
                            }}
                        >
                            {messages['fsmRoute_routesTracker_modalfilters_clearAll']}
                        </span>
                    </Grid>
                    <Grid item className="text-right">
                        <IconButton
                            type="icon"
                            icon="delete"
                            tooltip={messages['fsmRoute_routesTracker_modalfilters_clearFilters']}
                            placement="left"
                            onClick={() => {
                                clearFilters()
                            }}
                        />
                    </Grid>
                </Grid>
            </SidePanelHeader>
            <SidePanelBody style={{ height: '90%' }}>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    }}
                >
                    <div style={{ width: '100%' }}>
                        <Grid 
                            container
                            wrap="nowrap"
                            direction="column"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            sx={{ gridGap: 10 }}
                            style={{ paddingTop: 15 }}
                            >
                            <Grid item style={{ width: '100%', paddingLeft: 5 }}>
                                <Select 
                                    name="driverSelect"
                                    textField="name"
                                    label={messages['fsmRoute_edit_panel_route_driver']}
                                    valueField="driverId"
                                    placeholder={messages['fsmRoute_edit_panel_route_driver']}
                                    isMulti={true}
                                    options={drivers}
                                    isDisabled={false}
                                    isLoading={loadingRoutes}
                                    isClearable={true}
                                    isSearchable={true}
                                    showPillsOutside={true}
                                    value={driversSelect || []}
                                    onChange={(value) => {
                                    setDriversSelect(value);
                                }}/>
                            </Grid>

                            <Grid item style={{ width: '100%', paddingLeft: 5 }}>
                                <Pill
                                    item={noDriverFilter}
                                    onClick={(item) => {
                                        setNoDriverFilter({...item, variant: item.variant == 'filled' ? 'none' : 'filled' })
                                        if(item.variant == 'none'){
                                            setDriversSelect([])
                                        }
                                    }}
                                    style={{ border: "2" }}
                                    colorField="default"
                                    variant={noDriverFilter?.variant}
                                />
                            </Grid>

                            <Grid item style={{ width: '100%', paddingLeft: 5 }}>
                                <Select 
                                    name="statusSelect"
                                    textField="label"
                                    label={messages['fsmRoute_routesTracker_modalfilters_status']}
                                    valueField="name"
                                    placeholder={messages['fsmRoute_routesTracker_modalfilters_status']}
                                    isMulti={true}
                                    options={ListRouteStatus}
                                    isDisabled={false}
                                    isClearable={true}
                                    isSearchable={true}
                                    showPillsOutside={true}
                                    value={statusSelect || []}
                                    onChange={(value) => {
                                        setStatusSelect(value);
                                }}/>
                            </Grid>
                            
                            <Grid item style={{ width: '100%', paddingLeft: 5 }}>
                                <div style={{ marginTop: 5}}>
                                    <TimeFrame
                                        isRequired
                                        filterSwitch={false}
                                        {...timeFrame}
                                        label={messages['route_required_field_schedule_at']}
                                        placeholder={messages['reportsMainRT_timeFrameLabel']}
                                        requiredMessage={messages["required_field"]}
                                        //customRangeDate={30}
                                        maxDate={moment().add(2, 'months').toDate()}
                                        dateFormat={dateformat || 'Y/m/d'}
                                    />
                                </div>
                            </Grid>  
                        </Grid> 
                    </div>
                </div> 
            </SidePanelBody>
            <SidePanelFooter>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    }}
                >
                    <Button
                        variant="secondary"
                        style={{ marginRight: 8 }}
                        onClick={handleToggle}
                    >
                        {messages['fsmRoute_routesTracker_modalfilters_close']}
                    </Button>
                </div>      
            </SidePanelFooter>
        </SidePanel>
        </div>
    )
}




export default ModalRouteFilters;